import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification } from '@reducers/notification';
import { disableFooter } from '@reducers/orders';
import { getObjectValue } from '@utility/utills';
import EventEmitter from '@utility/eventSubscribers';
import { flowType } from '@utility/userInfo';
import { urlSearchParams } from '../../utility/utills';
import cn from 'classnames';
import cardProcessingGiff from '@assets/JSON_Files/CreditCardProcessing.json';
import tapOrInsert2 from '@assets/JSON_Files/Insert_Debit_Card.json';
import tapDetectedGif from '@assets/images/payment/3-TapDetected.gif';
import tapOrInsert1 from '@assets/images/payment/tapCard.gif';
import tapOrInsert3 from '@assets/images/payment/swipeCard.gif';
import LazyLottieLoader from '../../utility/lazyLottieLoader';
import { TouchableButton } from '@components/common/Touchable';
import { LABEL } from '../../veriables';

const Pay = ({ ...props }) => {

  //props Destructuring
  const {
    serverAppTheme,
    paymentCallBack,
    handleFailureRoute,
    handleRouteRetry,
  } = props;

  const isServerApp = flowType() === 'serverApp';
  const storeInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')), {});

  const ingenicoUseSaleMethod = getObjectValue(() => storeInfo?.ingenicoUseSaleMethod, false);
  const cardReaderType = getObjectValue(() => storeInfo?.cardReaderType, null);

  const paymentTypeForIngenicoUseSale = ingenicoUseSaleMethod && [1, 2].includes(cardReaderType);


  // State Management
  const [state, setState] = useState({});
  const [image, setImage] = useState();
  const [cancelDisabled, setCancelDisabled] = useState(false);

  //React Hooks

  useEffect(() => {
    if (urlSearchParams('preAuth')) {
      if (window.ReactNativeWebView) {
        EventEmitter.onProcessCreditTokenize(creditSaleListener);
        EventEmitter.onSuccessCreditTokenize(creditSaleSuccessListener);
        EventEmitter.onErrorCreditTokenize(failureListener);
      }
    } else {
      console.log('emitter event', {ingenicoUseSaleMethod, cardReaderType})
      if (isServerApp && !paymentTypeForIngenicoUseSale) {
        console.log("event calling processPayment")
        EventEmitter.processCredit(creditSaleListener);
        EventEmitter.processPayment(creditSaleSuccessListener, creditSaleListener ,failureListener);
      } else if (isServerApp && paymentTypeForIngenicoUseSale){
        console.log("event calling processCreditSale");
        EventEmitter.processCredit(creditSaleListener);
        EventEmitter.processCreditSale(creditSaleSuccessListener, failureListener);
      } else {
        EventEmitter.processCreditSale(creditSaleSuccessListener, failureListener);
      }
    }
    return () => {
      EventEmitter.removeListeners('onProcessCreditTokenize', creditSaleListener);
      EventEmitter.removeListeners('onSuccessCreditTokenize', creditSaleSuccessListener);
      EventEmitter.removeListeners('onErrorCreditTokenize', failureListener);
      EventEmitter.removeListeners('processCredit', creditSaleListener);
      EventEmitter.removeListeners('processPayment', creditSaleListener);
      EventEmitter.removeListeners('processCreditSale', creditSaleSuccessListener);
    };
  }, []);
 
  // Timer for payment may use in future
  
  useEffect(() => {
    let interval = null;

    if (false && !storeInfo?.disablePaymentTimer) {
      let i = 60;
      interval = setInterval(() => {
        if (i === 1) {
          clearInterval(interval);
          handleRouteRetry();
        }

        // setTimer((timerValue) => timerValue - 1);
        i -= 1;
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  // Methods


  const returnProcess = () => {
    return tapOrInsert2;
  };
  const tapDetected = () => {
    return tapDetectedGif;
  }
  const cardProcessing = () => {
    return cardProcessingGiff;
    // return  <Lottie animationData={swipeGiftCard} loop={true} autoplay={true} speed={1} />
  }

  const returnErrorRotated = () => {
      return tapOrInsert1;
  };

  const responseArray = [];
  const creditSaleListener = (response) => {
    switch (response.code) {
          case 'LOGIN_TO_GATEWAY': {
            responseArray.push(response.code);
            // <Lottie animationData={swipeGiftCard} loop={true} autoplay={true} speed={1} />
            setImage(cardProcessingGiff)
            setState({ screenName: 'LOGGING_INTO_GATEWAY', displayName: 'Logging into Gateway' });
            break;
          }
          case 'INSERT_TAP_SWIPE_CARD': {
            responseArray.push(response.code);
            setImage(tapOrInsert2);
            setState({ screenName: 'INSERT_CARD', displayName: 'TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY' });
            break;
          }
          case 'TAP_SWIPE_CARD':
          case 'WAITING_FOR_SWIPE': {
            responseArray.push(response.code);
            setImage(tapOrInsert2);
            setState({ screenName: 'INSERT_CARD', displayName: 'Swipe Card' });
            break;
          }
          case 'SWIPE_CARD': {
            responseArray.push(response.code);
            setImage(tapOrInsert3);
            setState({ screenName: 'INSERT_CARD', displayName: 'Swipe Card' });
            break;
          }
          case 'SWIPE_DETECTED': {
            setCancelDisabled(true);
            responseArray.push(response.code);
            setImage(tapOrInsert3);
            setState({
              screenName: 'PAYMENT_PROCESSING',
              method: 'CARDMETHOD.SWIPE',
              mode: 'MODE.CARD',
              displayName: 'Payment Processing'
            });
            break;
          }
          case 'TAP_DETECTED': {
            setCancelDisabled(true);
            responseArray.push(response.code);
            setImage(tapDetected());
            setState({
              screenName: 'PAYMENT_PROCESSING',
              method: 'CARDMETHOD.TAP',
              mode: 'MODE.NFC',
              displayName: 'Tap Detected'
            });
            break;
          }
          case 'CARD_INSERTED': {
            setCancelDisabled(true);
            responseArray.push(response.code);
            setImage(returnProcess());
            setState({
              screenName: 'PAYMENT_PROCESSING',
              method: 'CARDMETHOD.INSERT',
              mode: 'MODE.CARD',
              displayName: 'Card Inserted'
            });
            break;
          }
          case 'REMOVE_CARD': {
            responseArray.push(response.code);
            setImage(returnProcess());
            setState({
              screenName: 'COMPLETED',
              displayName: 'Completed'
            });
            break;
          }
          case 'APPLICATION_SELECTION_COMPLETED': {
            responseArray.push(response.code);
            break;
          }
          case 'GETTING_ONLINE_AUTHORIZATION': {
            responseArray.push(response.code);
            break;
          }
          case 'UPDATING_TRANSACTION': {
            responseArray.push(response.code);
            setImage(cardProcessing());
            setState({
              screenName: 'UPDATING_TRANSACTION',
              message: response.message,
              displayName: 'Processing'
            });
            break;
          }
          case 'GETTING_CARD_VERIFICATION': {
            responseArray.push(response.code);
            break;
          }
          case 'RESWIPE_CARD': {
            responseArray.push(response.code);
            setState({
              screenName: 'INSERT_CARD',
              message: response.message,
              displayName: 'Insert Card'
            });
            break;
          }
          case 'REINSERT_CARD': {
            responseArray.push(response.code);
            setState({
              screenName: 'INSERT_CARD',
              message: response.message,
              displayName: 'Reinsert Card'
            });
            break;
          }
          case 'SWIPE_NOT_ALLOWED': {
            responseArray.push(response.code);
            setState({
              screenName: 'SWIPE_NOT_ALLOWED',
              message: response.message,
              displayName: 'Swipe Not Allowed'
            });
            break;
          }
          case 'CHIP_CARD_SWIPE_FAILED': {
            responseArray.push(response.code);
            setState({ screenName: 'INSERT_CARD', message: response.message });
            break;
          }
          case 'UNKNOWN_RESPONSE': {
            responseArray.push(response.code);
            setState({ screenName: 'INSERT_CARD', message: response.message });
            break;
          }
          case 'CONTACTLESS_INTERFACE_FAILED': {
            responseArray.push(response.code);
            setImage(returnErrorRotated());
            setState({ screenName: 'INSERT_CARD', message: response.message });
            break;
          }
          case 'MULTIPLE_CONTACTLESS_CARDS_DETECTED': {
            responseArray.push(response.code);
            setImage(returnErrorRotated());
            setState({ screenName: 'MULTIPLE_CONTACTLESS_CARDS_DETECTED', message: response.message });
            break;
          }
          case 'ERROR_READING_CONTACTLESS_CARD':
            responseArray.push(response.code);
            setState({ screenName: 'INSERT_CARD', displayName: 'ERROR READING CONTACTLESS CARD - TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY' });
            break;
          case 'INVALID_INPUT':
            responseArray.push(response.code);
            setState({
              screenName: 'INVALID_INPUT',
              message: response.message,
              displayName: 'Invalid input'
            });
            break;
          case 'DEVICE_ERROR':
            responseArray.push(response.code);
            setState({
              screenName: 'INSERT_CARD',
              message: response.message,
              displayName: 'Device error'
            });
            break;
          case 'APPLICATION_SELECTION_NOT_SUPPORTED':
            responseArray.push(response.code);
            setState({
              screenName: 'INSERT_CARD',
              message: response.message,
              displayName: 'Application selection not supported'
            });
            break;
          default: {
            console.info('payment code not handled', response.code, response.message);
          }
        }
  };

  const creditSaleSuccessListener = (message) => {
    paymentCallBack(message, null, responseArray);
  };

  const failureListener = (err) => {
    handleFailureRoute(err, responseArray, urlSearchParams('preAuth'));
  };

  const tryCancelPayment = () => {
    if (cancelDisabled) {
      return;
    }

    // This is more like a fire-and-forget operation
    // If it succeeds, the payment transaction is aborted, so this event's response doesn't really matter, so we just log it
    EventEmitter.tryCancelPayment(
      result => {
        console.log('tryCancelPayment', result);
      },
      error => {
        const errorMessage = error?.message || 'Error trying to cancel payment';
        console.error('tryCancelPayment errored: ' + errorMessage, errorMessage);
      }
    );
  };

  // HTML CSS Code

  return (
    <div
      className="col-12 col-md-12 px-0 h-100"
      style={{
        background: serverAppTheme?.background_color,
        color: serverAppTheme?.primary_text,
      }}
    >
      {["kiosk"].includes(flowType()) ? (
        <span></span>
      ) : (
        // <div className="row h-100 w-100 align-items-center justify-content-center">
        //   <div className="col-12 d-flex align-items-center justify-content-center fs-40">
        //     { state && state.displayName === 'TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY'
        //       ? (
        //         <span>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">TAP OR INSERT CARD</div>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">OR</div>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">TAP PHONE FOR APPLE/GOOGLE PAY</div>
        //         </span>)
        //       : state.displayName}
        //   </div>
        //   <div className={`col-12 d-flex align-items-center justify-content-center ${style.rotate}`}>
        //     <img src={image} alt="" />
        //   </div>
        // </div>
        <>
          <div className="col-12 p-0 h-100 row mx-0 px-0 text-center">
            <div
              style={{
                backgroundColor: "transparent",
                left: "16px",
                border: "none",
              }}
              className={cn(
                "col-12 px-0 row w-100 justify-content-center align-items-center",
                state.displayName ===
                  "TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY"
                  ? "h-82"
                  : "h-65",
                "col-12 px-0",
              )}
            >
              {typeof image === "object" && (
                  <LazyLottieLoader
                    animationData={image}
                    loop={true}
                    autoplay={true}
                    speed={1}
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
              )}
            </div>
            {state.displayName ===
              "TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY" ? (
              <div className={cn("fs-24 fw-600 text-center h-12 col-12")}>
                {isServerApp ? (
                  <div className="fs-20 mx-auto w-70 px-0 d-flex justify-content-center align-items-center fw-600 text-center">
                    TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY
                  </div>
                ) : (
                  <>
                    <div className="fs-24 fw-600  text-center">
                      TAP OR INSERT CARD
                    </div>
                    <div className="fs-24 fw-600 d-flex justify-content-center align-items-center text-center">
                      OR
                    </div>
                    <div className="fs-24 fw-600 d-flex justify-content-center align-items-center text-center">
                      TAP PHONE FOR APPLE/GOOGLE PAY
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="col-12 h-35 px-0">
                <div className={cn("fs_28 fw-600 h-75 col-12")}>
                  {state.displayName}
                </div>
              </div>
            )}
            <div
              style={{
                position: 'fixed', /* Fix the button to the bottom of the screen */
                left: 0,
                right: 0,
                bottom: '16px',
                padding: '0 16px',
                zIndex: 9999,
                // Prevent ANY pointer events from reaching children when cancel is disabled
                pointerEvents: cancelDisabled ? 'none' : 'auto'
              }}
            >
              <TouchableButton
                className="w-100 px-0 rounded btn-ripple fw-600 text-center"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  tryCancelPayment();
                }}
                style={{
                  height: '50px',
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  color: serverAppTheme?.cancleBtn_font,
                  fontSize: '24px',

                  // Disabled styles
                  opacity: cancelDisabled ? 0.35 : 1,
                  cursor: cancelDisabled ? 'not-allowed' : 'pointer',
                  filter: cancelDisabled ? 'grayscale(25%)' : 'none'
                }}
                disabled={cancelDisabled}
                rippleEffect={!cancelDisabled}
              >
                {LABEL().SWIPE_CARD_CANCEL}
              </TouchableButton>
            </div>
          </div>
          {/* <div className="col-12 p-0 h-60 row mx-0 justify-content-center align-items-end">
            <button
              type="button"
              className="btn70 od-btn-primary btn-primary btn-ripple mb-2 w-100 roundedLg"
          // onClick={processCreditSale}
              disabled={loading}
            >
              <div className="fs-18">{!loading ? 'Pay By Credit Card' : 'Payment Processing...' }</div>
            </button>
          </div> */}
        </>
      )}
    </div>
  );
};

// Redux Part
const mapStateToProps = ({
  storeChecks, oauth, storeInfo, payment, theme, orders,
}) => ({
  storeCheckList: storeChecks.storeChecksList,
  authResponse: payment.authResponse,
  userInfo: oauth.loggedInUserData,
  serverAppTheme: theme.serverAppTheme,
  seat: orders.seats,
  storeInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  disableFooter
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pay);
